export default "__VITE_ASSET__DJIx9$Hd__"